import {HiShieldCheck} from "react-icons/hi";
import Button from "../Button";
import {useContext} from "react";
import AuthenticationServiceContext from "../../tools/contexts/authenticatonService/AuthenticationServiceContext";
import ForeignerAuthenticationContext from "../../tools/contexts/authenticatonService/ForeignerAuthenticationContext";
import ForeignerAuthenticationServiceContext
    from "../../tools/contexts/authenticatonService/ForeignerAuthenticationContext";
const Final=()=>{
    const foreignerAuthAuthenticationContext=useContext(ForeignerAuthenticationServiceContext);
    const handleRedirect=()=>{
        const price=foreignerAuthAuthenticationContext?.process?.payment?.info ? foreignerAuthAuthenticationContext.process.payment.info.init_amount :null
        return foreignerAuthAuthenticationContext.handleRedirectToDivar({price,status:"success"})
    }
    return  <div>
                    <div className="flex justify-center mt-10">
                        <h1 className="text-3xl text-gray-600  ">
                            ونیفای
                        </h1>
                    </div>
                    <div className="w-11/12 md:w-6/12 mx-auto  flex flex-col mt-5 justify-center items-center  lg:w-5/12 xl:w-4/12 bg-white rounded-lg p-5 ">
                        <HiShieldCheck className="text-5xl mb-7 text-green-500"/>
                        <h1 className="font-bold mb-2  ">احراز هویت با موفقیت انجام شد</h1>


                        <Button onClick={handleRedirect} className="mt-5 w-full lg:w-10/12 rounded-lg text-sm" theme="green">بازگشت به دیوار</Button>
                    </div>
            </div>
}
export default Final;